import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, Home, PaintBucket, Zap, Shield, ArrowRight, Sparkles } from 'lucide-react';
import { services } from '../mockData';

const iconComponents = {
  Building2,
  Home,
  PaintBucket,
  Zap,
  Shield
};

// Map service titles to slugs
const titleToSlug = {
  'Fassadensanierung': 'fassadensanierung-stuttgart',
  'Dachsanierung': 'dachsanierung-stuttgart',
  'Innensanierung': 'innensanierung-stuttgart',
  'Energetische Sanierung': 'energetische-sanierung-stuttgart'
};

const Services = () => {
  return (
    <section id="leistungen" className="py-16 md:py-24 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-[#DC2626]/5 to-transparent rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-[#DC2626]/5 to-transparent rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center space-x-2 bg-[#DC2626]/10 px-4 py-1.5 rounded-full mb-4">
            <Sparkles className="w-4 h-4 text-[#DC2626]" />
            <span className="text-sm font-semibold text-[#DC2626]">Unsere Leistungen</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Professionelle
            <span className="block mt-2 bg-gradient-to-r from-[#DC2626] to-[#B91C1C] bg-clip-text text-transparent">
              Sanierungsleistungen
            </span>
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            Von der Fassade bis zum Dach – wir bieten Ihnen das komplette Spektrum der Altbausanierung.
          </p>
        </div>

        {/* Services List - Bild links, Text rechts, untereinander */}
        <div className="space-y-8 md:space-y-12 max-w-5xl mx-auto">
          {services.map((service, index) => {
            const IconComponent = iconComponents[service.icon];
            const isEven = index % 2 === 0;
            
            return (
              <div
                key={service.id}
                className={`group flex flex-col ${isEven ? 'md:flex-row' : 'md:flex-row-reverse'} gap-6 md:gap-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-500 overflow-hidden`}
              >
                {/* Image */}
                <div className="relative w-full md:w-2/5 h-64 md:h-80 overflow-hidden flex-shrink-0">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent md:bg-gradient-to-r md:from-transparent md:to-transparent"></div>
                  
                  {/* Icon Badge */}
                  <div className="absolute top-4 left-4">
                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#DC2626] to-[#B91C1C] flex items-center justify-center shadow-lg">
                      <IconComponent className="w-6 h-6 text-white" />
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
                  <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900 mb-3 group-hover:text-[#DC2626] transition-colors duration-300">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-6">
                    {service.description}
                  </p>
                  <Link
                    to={`/leistungen/${titleToSlug[service.title]}`}
                    className="inline-flex items-center gap-2 text-[#DC2626] font-semibold group-hover:gap-3 transition-all duration-300 self-start"
                  >
                    <span>Mehr erfahren</span>
                    <ArrowRight className="w-5 h-5" />
                  </Link>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA Button */}
        <div className="text-center mt-12 md:mt-16">
          <Link
            to="/leistungen"
            className="inline-flex items-center gap-2 bg-[#DC2626] text-white px-8 py-4 rounded-full font-bold hover:bg-[#B91C1C] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
          >
            Alle Leistungen ansehen
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Services;
